import React from 'react';
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import YouTube from 'react-youtube';
import cross from '../../images/landing/cross.svg';

const GameVideoModal = ({toggle, onCloseModal}) => {
  const opts = {
    // height: '490',
    // width: '800',
    playerVars: {
      autoplay: 1,
    },
  };
 
    return (
      <div>
        <Modal open={ toggle } onClose={onCloseModal}  classNames={ {
        modal: 'register video-modal',
        overlayAnimationIn: 'customEnterOverlayAnimation',
          overlayAnimationOut: 'customLeaveOverlayAnimation',
          modalAnimationIn: 'customEnterModalAnimation',
          modalAnimationOut: 'customLeaveModalAnimation',
      }} center
        >
          <button onClick={onCloseModal} className="cross btn"><img width="80%" src={cross} alt=""/></button>
          <YouTube className="youtube-div" videoId="Nx7iUBTxIv0" 
          opts={opts}
           />
        </Modal>
        </div>
    );
}
export default GameVideoModal;